// extracted by css-extract-rspack-plugin
export default {"root":"root-w7WDai text-cutoff"};